module.exports = __webpack_public_path__ + "static/media/agility-aura.b8361dbd.png";